/**
 * GA4 custom events
 *
 * - form_start:       first interaction with a Contact Form 7 form (once per form per page view)
 * - form_submit:      Contact Form 7 form submitted successfully (mail sent)
 * - phone_call_click: click on any tel: link
 *
 * Sent through window.gtag (provided by the ExactMetrics / Google Analytics plugin).
 */
(function () {
  'use strict';

  function sendEvent(name, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', name, params);
    } else {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(['event', name, params]);
    }
  }

  function formParams(form) {
    var idInput = form.querySelector('input[name="_wpcf7"]');
    var wrapper = form.closest ? form.closest('.wpcf7') : null;
    return {
      form_id: idInput ? idInput.value : '',
      form_name: wrapper && wrapper.id ? wrapper.id : (form.getAttribute('aria-label') || ''),
      page_path: window.location.pathname
    };
  }

  function getCf7Form(el) {
    while (el && el !== document) {
      if (el.tagName === 'FORM' && el.classList && el.classList.contains('wpcf7-form')) {
        return el;
      }
      el = el.parentNode;
    }
    return null;
  }

  // form_start — fire once per form on the first field interaction
  function onFormInteraction(e) {
    var form = getCf7Form(e.target);
    if (!form || form.getAttribute('data-form-started') === '1') {
      return;
    }
    form.setAttribute('data-form-started', '1');
    sendEvent('form_start', formParams(form));
  }
  document.addEventListener('focusin', onFormInteraction, true);
  document.addEventListener('input', onFormInteraction, true);

  // form_submit — CF7 dispatches wpcf7mailsent on the wrapper after a successful send
  document.addEventListener('wpcf7mailsent', function (e) {
    var form = e.target && e.target.tagName === 'FORM' ? e.target : (e.target.querySelector && e.target.querySelector('form.wpcf7-form'));
    var params = form ? formParams(form) : { form_id: '', form_name: '', page_path: window.location.pathname };
    if (e.detail && e.detail.contactFormId) {
      params.form_id = String(e.detail.contactFormId);
    }
    sendEvent('form_submit', params);
    if (form) {
      // allow a fresh form_start if the (reset) form is filled in again
      form.removeAttribute('data-form-started');
    }
  }, false);

  // phone_call_click — any tel: link, including ones added after page load
  document.addEventListener('click', function (e) {
    var el = e.target;
    while (el && el !== document) {
      if (el.tagName === 'A' && /^tel:/i.test(el.getAttribute('href') || '')) {
        sendEvent('phone_call_click', {
          phone_number: el.getAttribute('href').replace(/^tel:/i, ''),
          link_text: (el.textContent || '').replace(/\s+/g, ' ').trim(),
          page_path: window.location.pathname
        });
        return;
      }
      el = el.parentNode;
    }
  }, true);
})();
